var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"details-list",class:`details-list_${_vm.size}`},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"details-list__item"},[_c('span',[_vm._v(_vm._s(item.left))]),(_vm.middleLine)?_c('div',{staticClass:"details-list__dot-line"}):_vm._e(),_c('span',[_vm._v(_vm._s(item.right))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }